import axios from "axios"

export default {
    namespaced: true,
    state: {
        isLoading: false,
        formPayloadFilter: {},
        formConfig: [],
        saveFilters: {},
        reportResponse: {},
        info: {},
        dimensions: []
    },
    getters: {
        isLoading: (state) => {
            return state.isLoading
        },
        formPayloadFilter: (state) => {
            return state.formPayloadFilter
        },
        getConfig: (state) => {
            return state.formConfig
        },
        getReport: (state) => {
            return state.reportResponse
        },
        getInfo: (state) => {
            return state.info
        },
        getDimensions: (state) => {
            return state.dimensions
        },
    },
    actions: {
        async getConfig ({ commit }, payload) {
            commit('setIsLoading', true)
            try {
                const path = window.location.origin + '/report/config'
                const response = await axios.get(path, payload)

                commit('setIsLoading', false)
                commit('setGetConfig', response)
                return response
            } catch (error) {
                console.warn(error)
            }
            commit('setIsLoading', false)
        },

        async onSave (_, payload) {
            try {
                const path = '/api/report/insert'
                const response = await axios.post(path, payload)

                return response
            } catch (error) {
                console.warn(error)
            }
        },
        async getList ({ commit }, payload){
            commit('setIsLoading', true)
            try {
                const path = '/api/report'
                const response = await axios.get(path, { params: payload })
                commit('setIsLoading', false)
                return response;
            } catch (error) {
                console.warn(error)
            }
        },
        async queryBuild ({ commit }, params){
            commit('setIsLoading', true)
            try {
                const path = '/api/report/build_query/'+params.id
                const response = await axios.get(path, { params })
                commit('setReportData', response.data)
                commit('setIsLoading', false)
                return response.data
            } catch (error) {
                console.warn(error)
            }
        },
        async getInfo ({ commit, state }, id) {
            try {
                const path = '/api/report/template/info/'+id
                const response = await axios.get(path)
                await commit('setInfo', response.data)
                return state.info
            } catch (error) {
                console.warn(error)
            }
        },
        async onUpdate (_, payload) {
            try {
                const path = '/api/report/update/'+payload.id
                const response = await axios.post(path, payload.params)

                return response;
            } catch (error) {
                console.warn(error)
            }
        },
        async onDelete(_, id){
            try {
                const path = '/api/report/template/'+id
                const response = await axios.delete(path)

                return response.data;
            } catch (error) {
                console.warn(error)
            }
        }
    },
    mutations: {
        setIsLoading (state, payload) {
            state.isLoading = payload
        },
        setFormPayloadFilter (state, payload) {
            state.formPayloadFilter = payload
        },
        setGetConfig (state, payload) {
            state.formConfig = payload;
        },
        setReportData(state, payload) {
            state.reportResponse = payload;
        },
        setInfo(state, payload) {
            state.info = payload
        },
        setDimensions(state, payload) {
            state.dimensions = payload
        }
    },
}
